import { render } from "./FakeNumber.vue?vue&type=template&id=08a40f60&scoped=true"
import script from "./FakeNumber.vue?vue&type=script&lang=js"
export * from "./FakeNumber.vue?vue&type=script&lang=js"

import "./FakeNumber.vue?vue&type=style&index=0&id=08a40f60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08a40f60"

export default script